import React, { useEffect,useState,createRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';

import * as RestService from '../../services/eisRest';





  const BankAccountModal = (props) => {

   

    const [t] = useTranslation();      
    const [isOpen, setIsOpen] = useState(false);
    
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [bankAccount, setBankAccount] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const dialogRef = createRef();

    const currencyOptions = [
      { value: 'CZK', label: 'CZK' },
      { value: 'EUR', label: 'EUR' },            
      { value: 'PLN', label: 'PLN' },
      { value: 'USD', label: 'USD' },
    ];
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    useEffect(() => {      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('bankAccount/getBankAccount?id='+props.selectedRecord, null)
      .then((data) => {
           setBankAccount(data);})
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    const handleAlertDialogCallback = (clickedValue) => {
      setOpenAlertDialog(false);
      if(clickedValue==='OK'){
        RestService.callAnyApi('basic/deleteRecord?entity=bankAccount&id='+props.selectedRecord, null).then(
          (data) => {
            hideModal();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      //  console.log("BankAccountDatatable state.recordId:"+id);       
    }

    useEffect(() => {
      RestService.callAnyApi('bankAccount/getBankList', null).then((data) => { setBankList(data);}).catch((error) => {});
      RestService.callAnyApi('company/getDepartmentSelectList', null).then((data) => { setDepartmentList(data);}).catch((error) => {});
    
      
    }, []);
    
    
    
   // const onBankAccountSave = (data) =>{
   //   setBankAccount(data);
   //   props.parentCallback(isOpen);
  //    hideModal();
  //  }    
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
      bankAccount.entityId=props.entityId;
      bankAccount.bankId=values.bankId;
      bankAccount.currency=values.currency;
      bankAccount.departmentId=values.departmentId;
      bankAccount.iban=values.iban;

      RestService.callAnyApi(url, bankAccount)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
        bankId: bankAccount.bankId || "",
        currency: bankAccount.currency || "",
        departmentId: bankAccount.departmentId || "",
        iban: bankAccount.iban || "",
      },
      validationSchema: Yup.object({
         bankId: Yup.string()     
          .required(t('general.message.required')),
          currency: Yup.string()     
          .required(t('general.message.required')),
          iban: Yup.string()     
          .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('bankAccount/saveBankAccount',values);         
      }
    });

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('bankAccount.label.bankAccount')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                          <div class="col-12">
                              <div class="form-group">
                                <label>{t('bankAccount.label.bankName')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('bankId',value.value)}
                                      value={formik.values.bankId}
                                      options={bankList}     
                                />                                
                              </div>
                              {formik.touched.bankId && formik.errors.bankId ? (
                                <div style={{ color: 'red' }}>{formik.errors.bankId}</div>
                              ) : null} 
                            </div>                            
                            <div class="col-5">
                              <div class="form-group">
                                <label>{t('bankAccount.label.currency')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('currency',value.value)}
                                      value={formik.values.currency}
                                      options={currencyOptions}     
                                />                                
                              </div>
                              {formik.touched.currency && formik.errors.currency ? (
                                <div style={{ color: 'red' }}>{formik.errors.currency}</div>
                              ) : null} 
                            </div>            
                            <div class="col-12" style={props.selectedRecord!='' && props.entityName==='company' ? {} : { display: 'none' }}>
                              <div class="form-group">
                                <label>{t('bankAccount.label.department')}</label>                               
                                <CustomSelect
                                      className='input'
                                      onChange={value=>formik.setFieldValue('departmentId',value.value)}
                                      value={formik.values.departmentId}
                                      options={departmentList}     
                                />                                
                              </div>                             
                            </div>    
                            <div class="col-12">
                              <div class="form-group">
                                <label>{t('bankAccount.label.iban')}</label>
                                <input type="text" class="form-control" placeholder="" {...formik.getFieldProps('iban')} />
                              </div>
                              {formik.touched.iban && formik.errors.iban ? (
                                <div style={{ color: 'red' }}>{formik.errors.iban}</div>
                            ) : null} 
                            </div>                                                        
                    </Modal.Body>
                    <Modal.Footer>                          
                          <Button style={selectedRecord ? {} : { display: 'none' }} className="btn-danger" onClick={deleteRecord}>{t('general.button.delete')}</Button>    
                          <Button style={entityId ? {} : { display: 'none' }} className="btn-primary" type="submit">{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
                <AlertDialog
                open={openAlertDialog}
                message={t('general.message.areYouSure')}
                header={t('general.message.confirmDelete')}
                parentCallback={handleAlertDialogCallback}
                ></AlertDialog> 
      </>
    );
  };

 export default BankAccountModal;